var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"#ED2246","strokeWidth":"1.5"},React.createElement("path",{"d":"M225.925 2120.071L215.216 2120.071 215.216 2114 203 2126.017 215.216 2137.983 215.216 2132.014 236.784 2132.014 236.784 2125.992 249 2137.983 236.784 2150 236.784 2143.929 226.075 2143.929","transform":"translate(-202 -2113)"}))));
}

Send.defaultProps = {"width":"48","height":"38","viewBox":"0 0 48 38"};

module.exports = Send;

Send.default = Send;
